var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Create a Business"}},[_c('div',{staticClass:"d-flex flex-row justify-center my-10"},[_c('CreateBiz')],1),_c('Guides')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }